import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import Spinner from './components/Spinner';
import Home from './pages/Home';
import Blog from './pages/Blog';
import WhoWeAre from './pages/WhoWeAre';
import MediaGallery from './pages/MediaGallery';
import Resources from './pages/Resources';
import EdgeInfotech from './pages/EdgeInfotech';
import EdgePaisa from './pages/EdgePaisa';
import RojgarMitra from './pages/RojgarMitra';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Careers from './pages/Careers';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Spinner />
        <Topbar />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/media-gallery" element={<MediaGallery />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/edge-infotech" element={<EdgeInfotech />} />
            <Route path="/edge-paisa" element={<EdgePaisa />} />
            <Route path="/rojgar-mitra" element={<RojgarMitra />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
          </Routes>
        </main>
        <Footer />
        <BackToTop />
      </div>
    </Router>
  );
}

export default App;